<template>
    <v-container fluid class="pa-0">
      <v-row  align="center" justify="center" class="section-inner about-section pt-12 ma-0"  :class="{'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown }">

        <!-- LEFT: Text Content -->
        <v-col cols="12" md="5" justify="left">
          <h2 class="section-title font-weight-bold white--text mb-6 btngetstart_paragraph">
             {{ this.lg_header_about.title }}
          </h2>
          <p class="section-desc white--text mb-4">
            {{ this.lg_header_about.details }}
          </p>
          <p class="section-desc white--text mb-10">
              {{ this.lg_header_about.details2 }}
          </p>
          <v-btn
            color="white"
            large
             class="mb-1 black--text slide-btn btngetstart_paragraph"
            v-bind:style="{ backgroundColor:'#FFFFFF'}"
          >
          <!-- @click="onClickMenu('/register-account')" -->
           <h3>{{ this.lg_header_about.get_start }}</h3> 
          </v-btn>
        </v-col>


        <!-- RIGHT: Staggered Cards -->
           <v-col cols="12" md="5" justify="left">
          <div class="cards-wrapper">

            <div class="card-row  carddetail1_paragraph" :class="{'card-row--1': !$vuetify.breakpoint.smAndDown}">
              <v-card class="about-card pa-6" rounded="lg" elevation="2">
                <h3 class="card-title font-weight-bold mb-3">{{ lg_header_about.question1 }}</h3>
                <p class="card-desc">
                 {{ this.lg_header_about.subquestion1 }}
                </p>
              </v-card>
            </div>

            <div class="card-row carddetail2_paragraph" :class="{'card-row--2': !$vuetify.breakpoint.smAndDown}">
              <v-card class="about-card pa-6" rounded="lg" elevation="2">
                <h3 class="card-title font-weight-bold mb-3">{{ lg_header_about.question2 }}</h3>
                <p class="card-desc">
                 {{ this.lg_header_about.subquestion2 }}
                </p>
              </v-card>
            </div>

            <div class="card-row carddetail3_paragraph" :class="{'card-row--3': !$vuetify.breakpoint.smAndDown}">
              <v-card class="about-card pa-6" rounded="lg" elevation="2">
                <h3 class="card-title font-weight-bold mb-3">{{ lg_header_about.question3 }}</h3>
                <p class="card-desc">
                 {{ this.lg_header_about.subquestion3 }}
                </p>
              </v-card>
            </div>

            <div class="card-row carddetail4_paragraph" :class="{'card-row--4': !$vuetify.breakpoint.smAndDown}">
              <v-card class="about-card pa-6" rounded="lg" elevation="2">
                <h3 class="card-title font-weight-bold mb-3">{{ lg_header_about.question4 }}</h3>
                <p class="card-desc">
                  {{ this.lg_header_about.subquestion4 }}
                </p>
              </v-card>
            </div>

          </div>
        </v-col>
      </v-row>

         <v-row no-gutters  justify="center" class="my-16 pa-4 getintouch_paragraph" :class="{'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown }">
      <v-col class="" v-bind:style="{ align:'center'}" justify="center" cols="12" >
           <v-row v-bind:style="{ alignContent:'center',align:'left' }" class="ma-0 d-flex justify-center align-center "  >
          <h2 class="section-title" v-bind:style="{ color: '#000000'}">
           {{ this.lg_header_about.section2_title }}
          </h2>
          </v-row>

           <v-row v-bind:style="{ alignContent:'center',align:'left' }" class="ma-0 d-flex justify-center align-center "  >
          <p class="section-desc" v-bind:style="{ color: '#000000',align:'center' }">
            {{ this.lg_header_about.section2_details }}
          </p>
          </v-row>
<br/>
    <v-row v-bind:style="{ alignContent:'center',align:'left' }" class="ma-0 d-flex justify-center align-center mb-8"  >
                     <div class="get-started-wrapper show" >
              <a @click="onClickMenu('/contact')"  class="get-started-link">{{ this.lg_header_about.section2_btn }} &gt;</a>
            </div>
            </v-row>
      </v-col>
         </v-row>
         
    </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import { feature } from "../services/constants.js";
import { lg_header_about } from "./language/lg_header_about.js";
import { lg_header_feature } from "./language/lg_header_feature.js";
export default {
  name: "Contact",
  data: () => ({
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false,
  }),
   async beforeCreate() {
     this.$store.state.page_reload = false;
     this.$store.state.loadFooter = true;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_about = lg_header_about.lg_header_about_th
        : this.lg_header_about = lg_header_about.lg_header_about_en;

        localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_header_feature = lg_header_feature.lg_header_feature_th)
      : (this.lg_header_feature = lg_header_feature.lg_header_feature_en);

        // console.log("lg_login: " + JSON.stringify(this.lg_login));

       
    },
    async mounted() {
      const userId = localStorage.getItem(server.USER_ID);
       if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
      var toggler = document.getElementsByClassName("caret");
const removeAllactiveclass = (indexnotremove)=> {
  for (var i = 0; i < toggler.length; i++) {
    if(i !== indexnotremove){
      document.querySelectorAll(".nested")[i].classList.remove("active");
      toggler[i].classList.remove("caret-down");
    }
}
}

const indexIn = (selector, element)=> {
  for (var i = 0; i < selector.length; ++i)
    if (toggler[i] === element) return i;
  return -1;
}

for (var i = 0; i < toggler.length; i++) {
  toggler[i].addEventListener("click", function() {
    removeAllactiveclass(parseInt(indexIn("." + this.classList[i], this)));

     if(!document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.contains("active")){
      document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.add("active");
    }else{
      document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.remove("active");
    }

    if(toggler[parseInt(indexIn("." + this.classList[i], this))].classList.contains("caret-down")){
      toggler[parseInt(indexIn("." + this.classList[i], this))].classList.remove("caret-down");
    }else{
      toggler[parseInt(indexIn("." + this.classList[i], this))].classList.add("caret-down");
    }
  });
}


const titleElbtngetstart_paragraphs = document.querySelectorAll(".btngetstart_paragraph");
if (titleElbtngetstart_paragraphs.length > 0) {
  titleElbtngetstart_paragraphs.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add("btngetstart_paragraph--visible");
    }, 200 + index * 150); // delay ทีละตัว ให้ดู smooth ขึ้น
  });
}

const carddetail1_paragraphs = document.querySelectorAll(".carddetail1_paragraph");
if (carddetail1_paragraphs.length > 0) {
  carddetail1_paragraphs.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add("carddetail1_paragraph--visible");
    }, 200 + index * 150); // delay ทีละตัว ให้ดู smooth ขึ้น
  });
}

const carddetail2_paragraphs = document.querySelectorAll(".carddetail2_paragraph");
if (carddetail2_paragraphs.length > 0) {
  carddetail2_paragraphs.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add("carddetail2_paragraph--visible");
    }, 400 + index * 150); // delay ทีละตัว ให้ดู smooth ขึ้น
  });
}

const carddetail3_paragraphs = document.querySelectorAll(".carddetail3_paragraph");
if (carddetail3_paragraphs.length > 0) {
  carddetail3_paragraphs.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add("carddetail3_paragraph--visible");
    }, 600 + index * 150); // delay ทีละตัว ให้ดู smooth ขึ้น
  });
}

const carddetail4_paragraphs = document.querySelectorAll(".carddetail4_paragraph");
if (carddetail4_paragraphs.length > 0) {
  carddetail4_paragraphs.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add("carddetail4_paragraph--visible");
    }, 800 + index * 150); // delay ทีละตัว ให้ดู smooth ขึ้น
  });
}

    const paragraphs = document.querySelectorAll(".getintouch_paragraph");
document.addEventListener("scroll", function(){
  paragraphs.forEach((paragraph)=>{
    if(isInView(paragraph)){
      paragraph.classList.add("getintouch_paragraph--visible");
    }else {
      paragraph.classList.remove("getintouch_paragraph--visible");
    }
  })
});

          function isInView(element){
const rect = element.getBoundingClientRect();
return(
  rect.bottom > 0 &&
  rect.top < (window.innerHeight -200  || document.documentElement.clientHeight - 200 )
)
}
    },
    computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75%";
        case "sm":
          return "76%";
        case "md":
          return "60%";
        case "lg":
          return "40%";
        case "xl":
          return "40%";
      }
    },
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    },
    methods: {
      onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
    },
};
</script>

<style scoped>
/* ── Section: diagonal two-tone blue ── */
.about-section {
  position: relative;
  overflow: hidden;
  min-height: 580px;

  /* 
    ลูกศรแดงชี้: บนซ้ายเข้ม (#3d5a9e) → ขวาล่างอ่อน (#6b8ed6)
    ใช้ linear-gradient แนวทแยง 135deg
  */
  /* background: linear-gradient(135deg, #3d5a9e 0%, #4f6db8 40%, #6b8ed6 100%); */
  /* background:url('/public/bg-color-about.jpg') !important; */
   background-color:#215295 !important;
}

.section-inner {
  position: relative;
  min-height: 580px;
}

/* ── Left Col ── */
.left-col {
  position: relative;
  z-index: 1;
}


/* ── Right Col ── */
.right-col {
  position: relative;
  z-index: 1;
}

/* ── Staggered Cards ── */
.cards-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-row {
  display: flex;
}

/* card 1: ชิดซ้าย ยื่นออกมาครึ่งหน้าจอ */
.card-row--1 {
  padding-left: 0;
  padding-right: 130px;
}

/* card 2: เยื้องขวามากขึ้น */
.card-row--2 {
  padding-left: 90px;
  padding-right: 0;
}

/* card 3: กลับมาซ้ายนิดหน่อย */
.card-row--3 {
  padding-left: 0;
  padding-right: 70px;
}

/* card 4: เยื้องขวาสุด */
.card-row--4 {
  padding-left: 140px;
  padding-right: 0;
}

/* ── Card ── */
.about-card {
  background: #ffffff;
  border: none;
  width: 100%;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.about-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18) !important;
}

.card-title {
  font-size: 1.05rem;
  color: #1a1a2e;
  line-height: 1.3;
}

.card-desc {
  font-size: 0.875rem;
  line-height: 1.7;
  color: #5a6a85;
  margin: 0;
}

.about-section2 {
  background-color: #F1F7FB !important;
}

.get-started-wrapper {
  margin-top: 14px;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
}
 
.get-started-wrapper.show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.get-started-link {
  font-size: 16px;
  font-weight: 600;
  color: #215295 !important;
  text-decoration: none;
}
 
.get-started-link:hover {
  text-decoration: underline;
}

.btngetstart_paragraph {
  opacity: 0;
  transform: translateY(60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.btngetstart_paragraph--visible {
  opacity: 1;
  transform: translateY(0);
}

.getintouch_paragraph {
  opacity: 0;
  transform: translateY(60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.getintouch_paragraph--visible {
  opacity: 1;
  transform: translateY(0);
}

.carddetail1_paragraph {
  opacity: 0;
  transform: translateY(0px) scale(0.3);
  transition: opacity 1.5s ease, transform 1.5s ease;
}

.carddetail1_paragraph--visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.carddetail2_paragraph {
  opacity: 0;
  transform: translateY(0px) scale(0.3);
  transition: opacity 1.5s ease, transform 1.5s ease;
}

.carddetail2_paragraph--visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.carddetail3_paragraph {
  opacity: 0;
  transform: translateY(0px) scale(0.3);
  transition: opacity 1.5s ease, transform 1.5s ease;
}

.carddetail3_paragraph--visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.carddetail4_paragraph {
  opacity: 0;
  transform: translateY(0px) scale(0.3);
  transition: opacity 1.5s ease, transform 1.5s ease;
}

.carddetail4_paragraph--visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>